import { UiSchema } from '@rjsf/utils'
import { AnyObject } from '@feedyou/utils'
import { BotFeatures } from '@feedyou/schema'

import {
  HIDDEN_WIDGET,
  TEXTAREA_WIDGET,
  useBaseStepUiSchema
} from '../../../../../../features/schema'

export function useFormUiSchema(formData: AnyObject, sdkFeatures: BotFeatures[] = []): UiSchema {
  const uiSchema = useBaseStepUiSchema(sdkFeatures)

  uiSchema.tools = HIDDEN_WIDGET
  uiSchema.description = TEXTAREA_WIDGET
  uiSchema.instructions = { 'ui:widget': 'EditorWidget', isWrapTextEnabled: true }
  uiSchema.parameters = { 'ui:widget': 'EditorJavascriptWidget' }
  uiSchema.invokeLlmChatService = {
    kind: 'llm-chat',
    action: 'Invoke',
    'ui:widget': 'BotCloudServiceSelectWidget'
  }
  uiSchema.knowledgeBases = {
    items: {
      id: { 'ui:widget': 'KnowledgeBaseSelectWidget' },
      retrieval: {
        type: { 'ui:widget': 'hidden' },
        queryLlmChatService: {
          'ui:widget': 'BotCloudServiceSelectWidget',
          kind: 'llm-chat',
          action: 'KB search query'
        }
      }
    }
  }

  uiSchema.outputs = {
    type: HIDDEN_WIDGET,
    schema: { 'ui:widget': 'EditorJavascriptWidget' },
    description: { 'ui:widget': 'EditorJavascriptWidget' }
  }
  uiSchema.input = {
    items: {
      type: HIDDEN_WIDGET,
      content: TEXTAREA_WIDGET,
      output: TEXTAREA_WIDGET,
      items: { items: { type: HIDDEN_WIDGET } }
    }
  }

  return uiSchema
}
